import React from 'react';

export default function Logo(props) {
  return (
      <div className="logo">
		<img src="/assets/logo.png"/>
     </div>
  );
} 


// WEBPACK FOOTER //
// ./components/Logo.js